// extracted by mini-css-extract-plugin
export var image = "_ib-0";